export const DashPerformance = {
    centerId: 0,
    centerAlias: '',
    currentCountPendingEmrRegistration: 0,
    currentMinWaitEmrRegistration: 0,
    currentAvgWaitEmrRegistration: 0,
    currentMaxWaitEmrRegistration: 0,
    currentCountPendingHistory: 0,
    currentMinWaitFinishHistory: 0,
    currentAvgWaitFinishHistory: 0,
    currentMaxWaitFinishHistory: 0,
    currentCountPendingDisposition: 0,
    currentMinWaitDisposition: 0,
    currentAvgWaitDisposition: 0,
    currentMaxWaitDisposition: 0,
    currentCountPendingCompletion: 0,
    currentMinWaitCompleted: 0,
    currentAvgWaitCompleted: 0,
    currentMaxWaitCompleted: 0,
    countCompletedEmrRegistration: 0,
    minWaitEmrRegistration: 0,
    avgWaitEmrRegistration: 0,
    maxWaitEmrRegistration: 0,
    countCompletedHistory: 0,
    minWaitFinishHistory: 0,
    avgWaitFinishHistory: 0,
    maxWaitFinishHistory: 0,
    countCompletedDisposition: 0,
    minWaitDisposition: 0,
    avgWaitDisposition: 0,
    maxWaitDisposition: 0,
    countCompleted: 0,
    minWaitCompleted: 0,
    avgWaitCompleted: 0,
    maxWaitCompleted: 0,
    totalContacts: 0,
    totalAutoRuleOuts: 0,
    totalManualRuleOuts: 0,
    totalSoftRuleOuts: 0,
    totalExpiredRuleOuts: 0,
    totalLocationRuleOuts: 0,
    totalDisconnects: 0,
    totalConfirmedDonations: 0,
    conversionRate: 0,
    conversionRatePercent: 0,
    totalRuleOuts: 0,
    currentCountBackLog: 0,
    totalRuleOutPercent: 0,
    totalAutoRuleOutPercent: 0,
    totalManualRuleOutPercent: 0,
    totalSoftRuleOutPercent: 0,
    totalExpiredRuleOutPercent: 0,
    totalLocationRuleOutPercent: 0,
    totalDisconnectsPercent: 0
}

export const DashDonorData = {
    centerId: 0,
    centerAlias: 0,
    startedCount: 0,
    incompleteScreeningCount: 0,
    hardRuleOutCount: 0,
    softRuleOutCount: 0,
    nonUsRuleOutCount: 0,
    manuallyRuledOutCount: 0,
    expiredRuleOutCount: 0,
    incompleteHistoryCount: 0,
    preWorkupLabCount: 0,
    atCenterSelectCount: 0,
    confirmedDonated: 0,
    nddCount: 0,
    ddCount: 0,
    adpCount: 0,
    standardVoucherCount: 0,
    familyVoucherCount: 0,
    optedOutCount: 0,
    notContactedCount: 0,
    notContactedWaitAvg: 0,
    contactedCount: 0,
    workupScheduledCount: 0,
    workupCompletedCount: 0,
    preOpScheduledCount: 0,
    preOpCompletedCount: 0,
    surgeryCompletedCount: 0,
    inProgressSum: 0,
    ruledOutSum: 0,
    incompleteSum: 0,
    completedAllCount: 0,
    notManuallyRuledOut: 0,
    completedCount: 0,
    cr1RegisteredCount: 0,
    cr1ReferredCount: 0
}

export const DashSummaryVolume = {
    centerId: null,
    centerAlias: '',
    year: ' Total Contacts',
    janCount: 0,
    febCount: 0,
    marCount: 0,
    aprCount: 0,
    mayCount: 0,
    junCount: 0,
    julCount: 0,
    augCount: 0,
    sepCount: 0,
    octCount: 0,
    novCount: 0,
    decCount: 0,
    total: 0
}